/* eslint-disable react-hooks/exhaustive-deps */
// react
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"

// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import { AppDispatch } from "../../.."

// Kairos
import AlertComponent from "../../../components/AlertComponent"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import KadaiKentoKaigiService from "../../../service/budget/kadaiKentoKaigi/kadaiKentoKaigiService"
import {
  TWeeklyReportAllListGetReq,
  TWeeklyReportAllListGetRes,
  TWeeklyReportPrintReq,
  T週報全社,
} from "../../../service/budget/kadaiKentoKaigi/TKadaiKentoKaigi"
import { 予算_実績メニューコード } from "../../../constant/menuCode"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import { quotOrZero, decimalPlus } from "../../../ts/util/decimalUtil"
import { RootState } from "../../../globalStore/rootreducer"
import dayjs from "dayjs"
import { create合計Grid行, e項目 } from "./kadaiKentoKaigiUtil"

// number to string (小数点以下の丸めも実施)
/**
 * gridの行フォーマット作成用
 * @param i 数値
 * @param 項目 予算／実績／達成率
 * @return string
 */
export const cnvUriageStr = (i: number, 項目: string) => {
  if (項目 === "達成率") {
    return new Intl.NumberFormat("ja", {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(i)
  } else {
    return new Intl.NumberFormat().format(Math.round(i))
  }
}

/**
 * 業績会議　週報全社
 * @returns
 */
const WeeklyReportAllList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "WeeklyReportAllList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        // 予算実績行の数値と達成率行のパーセンテージを表示するため文字列に変換
        第１週str: (i: T週報全社) => cnvUriageStr(i.第１週金額, i.項目),
        第２週str: (i: T週報全社) => cnvUriageStr(i.第２週金額, i.項目),
        第３週str: (i: T週報全社) => cnvUriageStr(i.第３週金額, i.項目),
        第４週str: (i: T週報全社) => cnvUriageStr(i.第４週金額, i.項目),
        第５週str: (i: T週報全社) => cnvUriageStr(i.第５週金額, i.項目),
        第６週str: (i: T週報全社) => cnvUriageStr(i.第６週金額, i.項目),
        月間str: (i: T週報全社) => cnvUriageStr(i.月間金額, i.項目),
      },
    })

  /**
   * 合計collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createSummaryCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      calculatedFields: {
        // 予算実績行の数値と達成率行のパーセンテージを表示するため文字列に変換
        第１週str: (i: T週報全社) => cnvUriageStr(i.第１週金額, i.項目),
        第２週str: (i: T週報全社) => cnvUriageStr(i.第２週金額, i.項目),
        第３週str: (i: T週報全社) => cnvUriageStr(i.第３週金額, i.項目),
        第４週str: (i: T週報全社) => cnvUriageStr(i.第４週金額, i.項目),
        第５週str: (i: T週報全社) => cnvUriageStr(i.第５週金額, i.項目),
        第６週str: (i: T週報全社) => cnvUriageStr(i.第６週金額, i.項目),
        月間str: (i: T週報全社) => cnvUriageStr(i.月間金額, i.項目),
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TWeeklyReportAllListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TWeeklyReportAllListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new KadaiKentoKaigiService().getList(
        currentSearchCondition
      )
      const resData: T週報全社[] = []
      // 週ごとのフィールドを作成して格納する
      if (res.data.filter((d) => d.週番号 === 6).length > 0) {
        set第六週フラグ(true)
      } else {
        set第六週フラグ(false)
      }
      res.data.forEach((d: TWeeklyReportAllListGetRes) => {
        let rowData: T週報全社 = {
          所属部所コード: "",
          所属部所名: "",
          項目: "",
          月間金額: 0,
          第１週金額: 0,
          第２週金額: 0,
          第３週金額: 0,
          第４週金額: 0,
          第５週金額: 0,
          第６週金額: 0,
          報告テキスト１: "",
          報告テキスト２: "",
        }
        rowData.所属部所名 = d.所属部所名
        rowData.所属部所コード = d.所属部所コード
        rowData.項目 = d.項目
        rowData.報告テキスト１ =
          res.data.find(
            (r) =>
              r.週番号 === 当日週番号 &&
              r.所属部所名 === d.所属部所名 &&
              r.項目 === "実績"
          )?.報告テキスト１ ?? ""
        rowData.報告テキスト２ =
          res.data.find(
            (r) =>
              r.週番号 === 当日週番号 &&
              r.所属部所名 === d.所属部所名 &&
              r.項目 === "実績"
          )?.報告テキスト２ ?? ""

        // 金額は小数点以下を丸めて表示

        switch (d.週番号) {
          case 1:
            rowData.第１週金額 = d.金額
            resData.push(rowData)
            break
          case 2:
            rowData.第２週金額 = d.金額
            resData.push(rowData)
            break
          case 3:
            rowData.第３週金額 = d.金額
            resData.push(rowData)
            break
          case 4:
            rowData.第４週金額 = d.金額
            resData.push(rowData)
            break
          case 5:
            rowData.第５週金額 = d.金額
            resData.push(rowData)
            break
          case 6:
            rowData.第６週金額 = d.金額
            resData.push(rowData)
            break
          default:
            break
        }
      })
      // 部所・項目でGROUP BY的な処理
      const d = resData.reduce((result: T週報全社[], current) => {
        const element = result.find(
          (r) => r.所属部所名 === current.所属部所名 && r.項目 === current.項目
        )
        if (element) {
          element.月間金額 = decimalPlus([
            element.月間金額,
            current.第１週金額,
            current.第２週金額,
            current.第３週金額,
            current.第４週金額,
            current.第５週金額,
            current.第６週金額,
          ])
          element.第１週金額 = decimalPlus([
            element.第１週金額,
            current.第１週金額,
          ])
          element.第２週金額 = decimalPlus([
            element.第２週金額,
            current.第２週金額,
          ])
          element.第３週金額 = decimalPlus([
            element.第３週金額,
            current.第３週金額,
          ])
          element.第４週金額 = decimalPlus([
            element.第４週金額,
            current.第４週金額,
          ])
          element.第５週金額 = decimalPlus([
            element.第５週金額,
            current.第５週金額,
          ])
          element.第６週金額 = decimalPlus([
            element.第６週金額,
            current.第６週金額,
          ])
        } else {
          current.月間金額 = decimalPlus([
            current.第１週金額,
            current.第２週金額,
            current.第３週金額,
            current.第４週金額,
            current.第５週金額,
            current.第６週金額,
          ])
          result.push(current)
        }
        return result
      }, [])

      // 達成率を作成
      const gridRowData = d.reduce((result: T週報全社[], current) => {
        const yosan = result.find(
          (r) =>
            r.所属部所コード === current.所属部所コード && r.項目 === "予算"
        )
        if (
          yosan &&
          yosan.所属部所名 === current.所属部所名 &&
          current.項目 === "実績"
        ) {
          result.push(current)
          const tassei: T週報全社 = {
            所属部所名: yosan.所属部所名,
            所属部所コード: yosan.所属部所コード,
            項目: "達成率",
            月間金額: quotOrZero(current.月間金額, yosan.月間金額),
            第１週金額: quotOrZero(current.第１週金額, yosan.第１週金額),
            第２週金額: quotOrZero(current.第２週金額, yosan.第２週金額),
            第３週金額: quotOrZero(current.第３週金額, yosan.第３週金額),
            第４週金額: quotOrZero(current.第４週金額, yosan.第４週金額),
            第５週金額: quotOrZero(current.第５週金額, yosan.第５週金額),
            第６週金額: quotOrZero(current.第６週金額, yosan.第６週金額),
            報告テキスト１: yosan.報告テキスト１,
            報告テキスト２: yosan.報告テキスト２,
          }
          result.push(tassei)
        } else {
          result.push(current)
        }
        return result
      }, [])

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(gridRowData, pageSize) })

      // 合計グリッドの作成
      const summaryData: T週報全社[] = []
      summaryData.push(create合計Grid行(gridRowData, 当日週番号, e項目.予算))
      summaryData.push(create合計Grid行(gridRowData, 当日週番号, e項目.実績))

      summaryData.push({
        所属部所コード: "",
        所属部所名: 当日週番号 + "週",
        項目: "達成率",
        月間金額: quotOrZero(summaryData[1].月間金額, summaryData[0].月間金額),
        第１週金額: quotOrZero(
          summaryData[1].第１週金額,
          summaryData[0].第１週金額
        ),
        第２週金額: quotOrZero(
          summaryData[1].第２週金額,
          summaryData[0].第２週金額
        ),
        第３週金額: quotOrZero(
          summaryData[1].第３週金額,
          summaryData[0].第３週金額
        ),
        第４週金額: quotOrZero(
          summaryData[1].第４週金額,
          summaryData[0].第４週金額
        ),
        第５週金額: quotOrZero(
          summaryData[1].第５週金額,
          summaryData[0].第５週金額
        ),
        第６週金額: quotOrZero(
          summaryData[1].第５週金額,
          summaryData[0].第５週金額
        ),
        報告テキスト１: "",
        報告テキスト２: "",
      })

      summaryData.push(
        create合計Grid行(gridRowData, 当日週番号, e項目.運行実績)
      )

      setSummaryGridData({
        data: createSummaryCollectionView(summaryData, pageSize),
      })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TWeeklyReportAllListGetReq = queryString.parse(location.search)
    set年月(query.年月)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TWeeklyReportAllListGetReq => {
    return {
      年月: 年月 ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TWeeklyReportAllListGetReq
  ) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")
    return {
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set年月("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  /**
   * 明細グリッドセル結合マネージャー
   */
  class RestrictedMergeManager extends wjGrid.MergeManager {
    getMergedRange(p: wjGrid.GridPanel, r: number, c: number, clip = true) {
      var rng = null
      rng = new wjGrid.CellRange(r, c)
      const マージ判定用bindList: { binding: string; isRequired: boolean }[] = [
        {
          binding: "所属部所名",
          isRequired: true,
        },
      ]
      const マージ対象bindList: string[] = [
        "所属部所名",
        "報告テキスト１",
        "報告テキスト２",
      ]
      const isMergeCell = (rowNumber: number) => {
        return !マージ判定用bindList.find((bindListItem) => {
          const cellValue = p.getCellData(r, bindListItem.binding, true)
          const prevRowValue = p.getCellData(
            rowNumber - 1,
            bindListItem.binding,
            true
          )
          if (bindListItem.isRequired && !cellValue) return true
          return cellValue !== prevRowValue
        })
      }

      // bindListの列が全て同じ値であれば結合する
      if (マージ対象bindList.includes(p.columns[c].binding ?? "")) {
        // セルの現在位置の上のセルと比較
        while (rng.row > 0 && isMergeCell(rng.row)) {
          rng.row--
        }
        // セルの現在位置の下のセルと比較
        while (rng.row2 < p.rows.length - 1 && isMergeCell(rng.row2 + 2)) {
          rng.row2++
        }
        if (rng.isSingleCell) {
          rng = null
        }
      }
      return rng
    }
  }

  /**
   * 週報業績報告帳票印刷処理
   */
  const printWeeklyReportAll = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    const printCondition: TWeeklyReportPrintReq = {
      抽出条件_対象年月: 年月 ?? eigyobi,
    }
    try {
      const res = await new KadaiKentoKaigiService({
        responseType: "blob",
      }).printWeeklyReportAll(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * 部所業績報告帳票印刷処理
   */
  const printWeeklyReportBusyo = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    const printCondition: TWeeklyReportPrintReq = {
      抽出条件_対象年月: 年月 ?? eigyobi,
    }
    try {
      const res = await new KadaiKentoKaigiService({
        responseType: "blob",
      }).printWeeklyReportBusyo(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // サマリ用グリッド
  const [summaryFlexGrid, setSummaryFlexGrid] = useState<wjGrid.FlexGrid>()
  const [summaryGridData, setSummaryGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createSummaryCollectionView([], 1),
  })

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [年月, set年月] = useState<string | null | undefined>(eigyobi)
  const [当日週番号, set当日週番号] = useState<number>()
  const [第六週フラグ, set第六週フラグ] = useState(false)

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    const 当日 = dayjs(new Date())
    const 週番号 = Math.floor((当日.date() + 12 - 当日.day()) / 7)
    set当日週番号(週番号)

    document.title = `業績会議　週報全社`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">業績会議</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>

      <Row>
        <Col>
          <Card className="w-50rem">
            <Card.Body>
              <div>
                <Button disabled={true}>業績報告</Button>
                <Link
                  to={
                    util.getMenuPath(
                      予算_実績メニューコード.業績会議_週報部所別
                    )[0]
                  }
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button className="mx-2" disabled={isSearching}>
                    部所業績報告
                  </Button>
                </Link>
                <Link
                  to={
                    util.getMenuPath(
                      予算_実績メニューコード.業績会議_荷主売上一覧
                    )[0]
                  }
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button disabled={isSearching}>荷主売上一覧</Button>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-8rem">
                              <MonthInput
                                id="年月"
                                placeholder="年月"
                                value={年月}
                                defaultValue={eigyobi}
                                setValue={set年月}></MonthInput>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 合計カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <FlexGridOuter
                flexGrid={summaryFlexGrid}
                gridConstantProperties={
                  CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_TOTAL
                }
                setFlexGrid={setSummaryFlexGrid}
                gridData={summaryGridData}
                setGridData={setSummaryGridData}
                pageNumber={pageNumber}
                gridId={`${gridId}_1`}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                isShowGridFooter={false}
                isShowGridHeader={false}
                hasFilter={false}
                gridProperties={{
                  mergeManager: new RestrictedMergeManager(),
                  itemFormatter: (
                    panel: wjGrid.GridPanel,
                    r: number,
                    c: number,
                    cell: HTMLElement
                  ) => {
                    if (panel.cellType === wjGrid.CellType.ColumnHeader) {
                      cell.style.textAlign = "center"
                    }
                  },
                }}>
                <wjrGrid.FlexGridColumn
                  binding="所属部所名"
                  width={160}
                  cssClass="dummy-header-cell"
                  header="合計"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="項目"
                  width={96}
                  cssClass="dummy-header-cell"
                  header="項目"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="月間str"
                  width={128}
                  format={"n0"}
                  cssClass="number-col"
                  header="月間"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第１週str"
                  width={128}
                  format={"n0"}
                  cssClass="number-col"
                  header="第１週"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第２週str"
                  width={128}
                  format={"n0"}
                  cssClass="number-col"
                  header="第２週"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第３週str"
                  width={128}
                  format={"n0"}
                  cssClass="number-col"
                  header="第３週"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第４週str"
                  width={128}
                  format={"n0"}
                  cssClass="number-col"
                  header="第４週"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第５週str"
                  width={128}
                  format={"n0"}
                  cssClass="number-col"
                  header="第５週"></wjrGrid.FlexGridColumn>
                {第六週フラグ && (
                  <wjrGrid.FlexGridColumn
                    binding="第６週str"
                    width={128}
                    format={"n0"}
                    cssClass="number-col"
                    header="第６週"></wjrGrid.FlexGridColumn>
                )}
              </FlexGridOuter>
            </Card.Body>
          </Card>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                style={{ maxHeight: "auto", height: "calc(100vh - 52.5rem)" }}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                changePageSizeTargetNumberArray={[16, 32, 48, 64, 0]}
                gridId={`${gridId}_2`}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                gridProperties={{
                  mergeManager: new RestrictedMergeManager(),
                  itemFormatter: (
                    panel: wjGrid.GridPanel,
                    r: number,
                    c: number,
                    cell: HTMLElement
                  ) => {
                    if (panel.cellType === wjGrid.CellType.ColumnHeader) {
                      cell.style.textAlign = "center"
                    }
                  },
                }}
                headerComponent={
                  <div>
                    <Button
                      className="btn-done"
                      disabled={
                        !gridInitialized || gridData.data.items.length === 0
                      }
                      onClick={(e: any) => {
                        e.stopPropagation()
                        e.preventDefault()
                        printWeeklyReportAll()
                      }}>
                      <FontAwesomeIcon icon={faFileAlt} />
                      業績報告書印刷
                    </Button>
                    <Button
                      className="btn-done"
                      disabled={
                        !gridInitialized || gridData.data.items.length === 0
                      }
                      style={{ marginLeft: "0.5rem" }}
                      onClick={(e: any) => {
                        e.stopPropagation()
                        e.preventDefault()
                        printWeeklyReportBusyo()
                      }}>
                      <FontAwesomeIcon icon={faFileAlt} />
                      部所業績報告書印刷
                    </Button>
                  </div>
                }>
                <wjrGrid.FlexGridColumn
                  binding="所属部所名"
                  width={160}
                  cssClass="dummy-header-cell"
                  header="部所名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="項目"
                  width={96}
                  cssClass="dummy-header-cell"
                  header="項目"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="月間str"
                  width={128}
                  cssClass="number-col"
                  header="月間"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第１週str"
                  width={128}
                  cssClass="number-col"
                  header="第１週"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第２週str"
                  width={128}
                  cssClass="number-col"
                  header="第２週"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第３週str"
                  width={128}
                  cssClass="number-col"
                  header="第３週"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第４週str"
                  width={128}
                  cssClass="number-col"
                  header="第４週"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第５週str"
                  width={128}
                  cssClass="number-col"
                  header="第５週"></wjrGrid.FlexGridColumn>
                {第六週フラグ && (
                  <wjrGrid.FlexGridColumn
                    binding="第６週str"
                    width={128}
                    cssClass="number-col"
                    header="第６週"></wjrGrid.FlexGridColumn>
                )}
                <wjrGrid.FlexGridColumn
                  binding="報告テキスト１"
                  width={300}
                  wordWrap={true}
                  header="当月売上動向"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="報告テキスト２"
                  width={300}
                  wordWrap={true}
                  header="見込み"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default WeeklyReportAllList
